module.exports = "/images/twitter-reply.svg?d513f19a98af363049e5708e57864b04";